import { ColumnsType } from 'antd/es/table';
import { AllReviewsProps } from '../../../types';
import dayjs from 'dayjs';
import { Paths } from '../../../routes';
import { PageLink, Status } from '../../../components';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { statusArray } from '../../../helper';

dayjs.extend(quarterOfYear);

export const allReviewscolumns: ColumnsType = [
  {
    title: 'Name of Quarterly Review Cycle',
    key: 'name',
    sorter: (a: AllReviewsProps, b: AllReviewsProps) => {
      return a.name?.trim().localeCompare(b.name?.trim());
    },
    render: (data) => (
      <PageLink
        label={data.name}
        id={data.id}
        path={Paths.AssignedMentees}
        state={{
          from: 'mentor',
          isQuarter: true,
          selectedCycleId: data.cycleId,
          id: data.id,
        }}
      />
    ),
  },
  {
    title: 'Review Quarter and Year',
    dataIndex: '',
    key: 'year',
    render: (data: AllReviewsProps) => {
      const startDate = dayjs(data.startDate);
      const year = startDate.year();
      const month = startDate.month() + 1; // getMonth() returns 0-11

      let quarter;
      if (year <= 2024) {
        if (month >= 1 && month <= 3) {
          quarter = 4;
        } else if (month >= 4 && month <= 6) {
          quarter = 1;
        } else if (month >= 7 && month <= 9) {
          quarter = 2;
        } else if (month >= 10 && month <= 12) {
          quarter = 3;
        }
      } else {
        quarter = startDate.quarter();
      }

      return <div>{`Q${quarter} - ${year}`}</div>;
    },
  },
  {
    title: 'Mentee Deadline',
    dataIndex: 'menteeDeadline',
    key: 'menteeDeadline',
    sorter: (a: AllReviewsProps, b: AllReviewsProps) =>
      dayjs(a.menteeDeadline).diff(dayjs(b.menteeDeadline)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'Mentor Deadline',
    dataIndex: 'mentorDeadline',
    key: 'mentorDeadline',
    sorter: (a: AllReviewsProps, b: AllReviewsProps) =>
      dayjs(a.mentorDeadline).diff(dayjs(b.mentorDeadline)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'Quarterly Feedback Status',
    dataIndex: 'status',
    key: 'status',
    sorter: (a: AllReviewsProps, b: AllReviewsProps) => {
      const first = statusArray[Number(a.status)] || a.status;
      const next = statusArray[Number(b.status)] || b.status;
      return first.toString()?.trim().localeCompare(next?.trim());
    },
    render: (status) => <Status status={status} from="quarter" />,
  },
];
